export default function isMac(): boolean {
  return navigator.appVersion.indexOf('Mac') !== -1;
}
